import { useState } from "react";
import { useSelector } from "react-redux";

import { makeStyles, Typography } from "@material-ui/core";

import { OverviewTab } from "./tabs/overview";
import { CashFlowForecastTab } from "./tabs/cashFlowForecast";
import { HorizontalTabs } from "../../components/horizontalTabs";
import { SensitivityAnalysisTab } from "./tabs/sensitivityAnalysis";
import { DetailedSensitivityAnalysisTab } from "./tabs/detailedSensitivityAnalysis";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const PowerRevenuesPage = () => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  const [tab, setTab] = useState(0);
  const TabComponents = user.is_demo
    ? [OverviewTab, CashFlowForecastTab, SensitivityAnalysisTab, DetailedSensitivityAnalysisTab]
    : [OverviewTab, SensitivityAnalysisTab];
  const TabComponent = TabComponents[tab];

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h2">
        Power Revenues
      </Typography>

      <HorizontalTabs
        tab={tab}
        setTab={setTab}
        tabNames={
          user.is_demo
            ? [
                "Overview",
                "Cash Flow Forecast",
                "Sensitivity Analysis",
                "Detailed Sensitivity Analysis",
              ]
            : ["Overview", "Sensitivity Analysis"]
        }
      />
      <TabComponent />
    </div>
  );
};
